<template>
  <section class="editor-contents">
    <h1 v-if="entity">Contenus : {{ entity.name }} <small>({{ entity.description }})</small></h1>
    <router-link class="add el-button" :to="{ name: 'editor-content-create', params: {
        spaceId: $route.params.spaceId,
        entityId: $route.params.entityId,
      }}">Créer un contenu</router-link>
    <div class="g-container">
      <router-link v-for="content in contents" :key="content.contentId"
        :to="{ name: 'editor-content', params: {
            spaceId: $route.params.spaceId,
            entityId: $route.params.entityId,
            contentId: content.contentId,
            versionId: content.versionId
          }}">
        <strong class="lbl">{{ content.document[entity.displayField] }}</strong>
        <span class="status">{{ status[content.status] }}</span>
        <span class="updated-at">modifié le {{ content.metadata.createdAt | moment("DD/MM/YYYY à h:mm") }}</span>
      </router-link>
    </div>
  </section>
</template>

<script>
import api from '@/services/api';

export default {
  name: 'editor-contents',
  components: {
  },
  data() {
    return {
      contents: null,
      entity: null,
      status: {
        published: 'Publié',
        draft: 'Brouillon',
        archived: 'Archivé',
      },
    };
  },
  watch: {
    $route: 'fetchData',
  },
  async mounted() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      this.entity = await api.getEntity(this.$route.params.spaceId, this.$route.params.entityId);
      this.contents = await api.getContents(this.$route.params.spaceId, this.$route.params.entityId);
    },
  },
};
</script>

<style lang="sass">
.editor-contents
  .add
    position: absolute
    top: 60px
    right: 30px
    z-index: 2000
    background: #ff3c48
    color: white

  .g-container
    flex-direction: column
    .lbl
      width: 50%
      text-align: left
    > a
      display: flex
      justify-content: space-between
      width: 100%
      background: white
      padding: 0.8rem 1.5rem
      border-left: 3px solid #ff3c48
      border-radius: 2px
      font-size: 0.9rem
      & ~ a
        margin-top: 1rem
</style>
